module.exports = __webpack_public_path__ + "static/media/Alcibiades.ba622fcc.jpg";